/* eslint-disable max-len */
import React from "react"

import BaseSvgIcon from "../Base"

const TravelBenefitFill = (props) => (
  <BaseSvgIcon {...props} viewBox="0 0 44 44">
    <path
      d="M5.72006 33.7598C4.75006 33.7598 3.97007 34.6098 4.11007 35.6198C4.22007 36.4398 5.01007 37.0098 5.84007 37.0098H38.1501C38.9801 37.0098 39.7701 36.4398 39.8801 35.6198C40.0201 34.6198 39.2501 33.7598 38.2701 33.7598H5.72006Z"
      fill="#000"
    />
    <path
      d="M27.5597 14.3998L15.1097 7.91984C14.6097 7.65984 14.0297 7.61984 13.5097 7.80984L10.9397 8.74984C10.2997 8.97984 10.0797 9.76984 10.4997 10.3098L16.8397 18.2998L10.5797 20.5698L6.82969 18.2798C6.43969 18.0398 5.96969 17.9998 5.53969 18.1498L4.51969 18.5198C3.92969 18.7298 3.67969 19.4298 3.99969 19.9598L7.34969 25.6898C8.31969 27.3598 10.3497 28.0898 12.1597 27.4298L12.9697 27.1398L37.8497 18.0898C39.6697 17.4298 40.5997 15.4198 39.9397 13.6098C39.2797 11.7898 37.2697 10.8598 35.4597 11.5198L27.5697 14.3998H27.5597Z"
      fill="#000"
    />
  </BaseSvgIcon>
)

export default TravelBenefitFill
